import { render, staticRenderFns } from "./number.vue?vue&type=template&id=c4b749d4&scoped=true&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"
import style0 from "./number.vue?vue&type=style&index=0&id=c4b749d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b749d4",
  null
  
)

export default component.exports